import {
  createScreenViewedEvent,
  createComponentClickedEvent,
  createListScrolledEvent,
  createCardClickedEvent,
  track,
} from "./base"
import { type AnalysisListType } from "@/screens/analyze/utils/Properties"
import { type AppScreen } from "@/constants/Screens"

export const sortClicked = () => {
  track(
    createComponentClickedEvent({
      current_screen: "Properties",
      component_type: "icon",
      component_function: "show sort options",
    })
  )
}

export const sortByClicked = ({
  sort,
  sortValue,
}: {
  sort: string
  sortValue: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Properties",
      component_type: "menu_option",
      component_function: "sort",
      component_text: sort,
      clicked_values: {
        sort_value: sortValue,
      },
    })
  )
}

export const notificationActionClicked = (
  analysisId: string,
  currentScreen: AppScreen,
  enableNotifications: boolean
) => {
  track(
    createComponentClickedEvent({
      current_screen: currentScreen,
      component_type: "icon",
      component_function: !enableNotifications
        ? "disable notifications"
        : "enable notifications",
      clicked_values: {
        analysis_id: analysisId,
      },
    })
  )
}

export const favoritesActionClicked = (
  currentScreen: AppScreen,
  favorite: boolean
) => {
  track(
    createComponentClickedEvent({
      current_screen: currentScreen,
      component_type: "icon",
      component_function: !favorite ? "unfavorite" : "favorite",
    })
  )
}

export const propertiesViewed = ({
  currentTab,
}: {
  currentTab: AnalysisListType
}) => {
  track(
    createScreenViewedEvent({
      current_screen: "Properties",
      current_tab: currentTab,
    })
  )
}

export const propertiesListScrolled = ({
  scrolledTo,
}: {
  scrolledTo: number
}) => {
  track(
    createListScrolledEvent({
      current_screen: "Properties",
      list_type: "property",
      scrolled_to: scrolledTo,
    })
  )
}

export const propertyCardClicked = ({
  cardListNumber,
  propertyType,
  propertyAddress,
  roi,
  price,
  arv,
  profit,
  isNew,
}: {
  cardListNumber: number
  propertyType: "sourced" | "shared" | "analysis"
  propertyAddress: string
  roi?: string
  price?: number
  arv?: number
  profit?: number
  isNew: boolean
}) => {
  track(
    createCardClickedEvent({
      current_screen: "Properties",
      to_screen: "Subject Property",
      card_type: "property",
      card_list_number: cardListNumber,
      card_values: {
        property_type: propertyType,
        property_address: propertyAddress,
        deal_type: roi,
        price,
        arv,
        profit,
        is_new: isNew,
      },
    })
  )
}

